module.exports = __webpack_public_path__ + "static/img/file_css.ef28af39.png";